import { Action } from '../actions';
import { UPDATE_BANNERS_PREVIEW } from '../actions/banners-preview';
import { BannersPreviewDataDict } from '../typings/state';

const initialState = {};

export function bannersPreviewData(
    state: BannersPreviewDataDict = initialState,
    action: Action
): BannersPreviewDataDict {
    switch (action.type) {
        case UPDATE_BANNERS_PREVIEW: {
            return {
                ...state,
                ...action.bannersPreviewData
            };
        }
        default:
            return state;
    }
}
